import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  LabelAPIRawRequestBodyType,
  LabelAPIRequestBodyType
} from './api-request-body';

export type LabelAPIRawSuccessResponseType = {
  id: number;
  name: string; // ラベル名 [1..50] characters
  color: string; // [1..7] characters /^#[0-9a-fA-F]{6}$/
  model_annotation_count: number; // 学習での利用数
  project_annotation_count: number; // プロジェクトでの利用数
  can_be_deleted: boolean;
};

export type LabelAPIRawValidationErrorType = APIRawValidationErrorType<
  LabelAPIRawRequestBodyType
>;

export type LabelAPIValidationErrorType = APIValidationErrorType<
  LabelAPIRequestBodyType
>;

export type ILabelAPIValidationErrorType = IAPIValidationErrorType<
  LabelAPIRequestBodyType
>;

export const ILabelAPIValidationErrorFactory = IRecord<
  LabelAPIValidationErrorType
>({
  name: IList<string>(),
  hue: IList<string>()
});
